import { render, staticRenderFns } from "./PasswordChangePage.vue?vue&type=template&id=7a5eb9f0&"
import script from "./PasswordChangePage.vue?vue&type=script&lang=js&"
export * from "./PasswordChangePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports